export default __webpack_public_path__ + "static/media/placeholder_dummy2016-beauty01-mobile-de.9e446157.png";